var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 509,
    height: 508,
    viewBox: "0 0 509 508",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 509,
    height: 508,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 316.5L66 248L76.5 237L139 294.5L243 169.5L360.5 286L433 221L443 232L360 306.5L244 191.5L140.5 316.5Z",
    fill: "black",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141 401L153 410.5L244.5 300L419.5 479L430.5 469L243 277.5L141 401Z",
    fill: "#0097FE",
    stroke: "#0097FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M341 71L326 67L325.5 67.5C268.5 150 195 127.5 193 33.5L178 30C174.5 139.5 273.5 176 341 71Z",
    fill: "#FF6821",
    stroke: "#FF6821"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWbg);
export default __webpack_public_path__ + "static/media/logoWbg.6eee9bf00e585c2e931610c4202ff0e3.svg";
export { ForwardRef as ReactComponent };